import { api } from "@/lib/api";
import {
  ReservationDayDto,
  reservationDayDtoListSchema,
  reservationDayFromDto,
} from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getReservationDaysQueryOptions(
  reservationId: string | undefined,
) {
  return queryOptions({
    queryKey: ["reservation-days", reservationId],
    queryFn: async () => {
      const result: Array<ReservationDayDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/reservation-days",
          reservationDayDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              ReservationId:
                reservationId === undefined
                  ? undefined
                  : Number.parseInt(reservationId),
            },
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(reservationDayFromDto);
    },
  });
}

export function useGetReservationDays(reservationId: string) {
  return useQuery({
    ...getReservationDaysQueryOptions(reservationId),
  });
}

export function useGetAllReservationDays() {
  return useQuery({
    ...getReservationDaysQueryOptions(undefined),
  });
}
